import styled from "styled-components"

export const Poppins = styled.div`
  font-family: "Poppins", sans-serif;
`
